import React from "react";
import "../nav/Navigation.css";
import {Link} from "react-router-dom";

interface Props {
  name: string | undefined | null;
  count: number;
  bold: boolean;
  tagLink?: string | undefined | null;
}

export const getDisplayPhotoTag = (tag: string | undefined | null): string => {
    return tag && tag.trim() ? tag : "unknown";
};

function PhotoTag(props: Props) {
    const displayName = getDisplayPhotoTag(props.name);
    const tagLink = getDisplayPhotoTag(props.tagLink || props.name);

    return (
        <>
            <Link to={"/photos/" + encodeURIComponent(tagLink)}>
              <div className={`user-tag d-inline-block`}>
                <span className={`${props.bold ? "bold-text" : ""}`}>{displayName}</span> {props.count > 0 && <span style={{fontSize: "0.7em"}}>{props.count}</span>}
              </div>
            </Link>
        </>
    )
}

export default PhotoTag;
